export default __webpack_public_path__ + "assets_globe.a4427fe8.svg";